module.exports = __webpack_public_path__ + "img/credit-one-club-gal-8.43e61df2.jpg";